import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { BeneficiariesInsightWidgetsRoutes } from '@repo/shared/routes-beneficiary-insight-widgets'
import { AxiosInstance } from 'axios'

import { IBeneficiariesInsightsApi } from '@/spi/api/beneficiaries-insights'

export const buildBeneficiariesInsightsApi = (
  axiosInstance: AxiosInstance,
): IBeneficiariesInsightsApi => {
  return {
    addWidget: async ({ organizationId, attributes }) => {
      const response = await tryCatch(async () =>
        axiosInstance.post<typeof BeneficiariesInsightWidgetsRoutes.createOne.response>(
          BeneficiariesInsightWidgetsRoutes.createOne.getPath({ organizationId }),
          {
            payload: attributes,
          } satisfies typeof BeneficiariesInsightWidgetsRoutes.createOne.request,
        ),
      )
      if (hasError(response)) return handleError(response)
      return response.data
    },
    getComputedWidgets: async ({ organizationId }) => {
      const response = await tryCatch(async () =>
        axiosInstance.get<typeof BeneficiariesInsightWidgetsRoutes.getAllComputed.response>(
          BeneficiariesInsightWidgetsRoutes.getAllComputed.getPath({ organizationId }),
        ),
      )
      if (hasError(response)) return handleError(response)
      return response.data
    },
    getWidget: async ({ organizationId, widgetId }) => {
      const response = await tryCatch(async () =>
        axiosInstance.get<typeof BeneficiariesInsightWidgetsRoutes.getOne.response>(
          BeneficiariesInsightWidgetsRoutes.getOne.getPath({ organizationId, widgetId }),
        ),
      )
      if (hasError(response)) return handleError(response)
      return response.data
    },
    getComputedWidget: async ({ organizationId, widgetId }) => {
      const response = await tryCatch(async () =>
        axiosInstance.get<typeof BeneficiariesInsightWidgetsRoutes.getComputed.response>(
          BeneficiariesInsightWidgetsRoutes.getComputed.getPath({ organizationId, widgetId }),
        ),
      )
      if (hasError(response)) return handleError(response)
      return response.data
    },
    getAllWidgets: async ({ organizationId }) => {
      const response = await tryCatch(async () =>
        axiosInstance.get<typeof BeneficiariesInsightWidgetsRoutes.getAll.response>(
          BeneficiariesInsightWidgetsRoutes.getAll.getPath({ organizationId }),
        ),
      )
      if (hasError(response)) return handleError(response)
      return response.data
    },
    toggleWidgetDisplayInDashboard: async ({ organizationId, widgetId }) => {
      const response = await tryCatch(async () =>
        axiosInstance.patch<
          typeof BeneficiariesInsightWidgetsRoutes.toggleDisplayInDashboard.response
        >(
          BeneficiariesInsightWidgetsRoutes.toggleDisplayInDashboard.getPath({
            organizationId,
            widgetId,
          }),
        ),
      )
      if (hasError(response)) return handleError(response)
      return response.data
    },
    updateWidget: async ({
      organizationId,
      widgetId,
      title,
      type,
      description,
      width,
      height,
      position,
      metrics,
      dimensions,
      filters,
    }) => {
      const response = await tryCatch(async () =>
        axiosInstance.patch<typeof BeneficiariesInsightWidgetsRoutes.patchOne.response>(
          BeneficiariesInsightWidgetsRoutes.patchOne.getPath({ organizationId, widgetId }),
          {
            payload: {
              title,
              description,
              type,
              width,
              height,
              position,
              metrics,
              dimensions,
              filters,
            },
          } satisfies typeof BeneficiariesInsightWidgetsRoutes.patchOne.request,
        ),
      )
      if (hasError(response)) return handleError(response)
      return response.data
    },
    deleteWidget: async ({ organizationId, widgetId }) => {
      const response = await tryCatch(async () =>
        axiosInstance.delete<typeof BeneficiariesInsightWidgetsRoutes.deleteOne.response>(
          BeneficiariesInsightWidgetsRoutes.deleteOne.getPath({ organizationId, widgetId }),
        ),
      )
      if (hasError(response)) return handleError(response)
      return response.data
    },
  }
}
